export var INTRO_TEXT = 'intro-text';
//# sourceMappingURL=constants.js.map